export default __webpack_public_path__ + "static/media/bmw.c803ea82.svg";